import PropTypes from "prop-types";
import { Form } from "antd";
import { EditableContext } from "../../context/CollectionEditableRowContext";

const EditableRowTable = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};

EditableRowTable.propTypes = {
    index: PropTypes.number,
};

export default EditableRowTable;